import { type KeystoneReferral } from "data/keystone-api-mapping";
import { checkForNaStringValue } from "utils";

/** Heading for eligible / ineligible write-out cards (strip prefix; grouped → “Multiple issues”). */
export function getReferralWriteOutCardHeading(
  referral: KeystoneReferral,
): string | null {
  const { issueStatement, groupedIssueStatements } = referral;
  let raw = issueStatement?.replace(/^.*? - /, "") ?? "";
  if (groupedIssueStatements?.length) {
    raw = "Multiple issues";
  }
  return checkForNaStringValue(raw);
}

export function getReferralReasonings(referral: KeystoneReferral): string[] {
  const { groupedReasonings, reasoning } = referral;
  const reasoningDisplay = checkForNaStringValue(reasoning ?? "");
  if (groupedReasonings?.length) {
    return groupedReasonings;
  }
  if (reasoningDisplay) {
    return [reasoningDisplay];
  }
  return [];
}

export function formatReferralWriteOutCardSubheading(
  referral: KeystoneReferral,
): string {
  const { locationDetail } = referral;
  const locationDisplay = checkForNaStringValue(locationDetail ?? "");
  if (locationDisplay) {
    return `Observed at ${locationDisplay.toLowerCase()}`;
  }

  return "";
}
